/* eslint-disable max-len */
import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const ThumbsUpIcon: FC<IconProps> = ({ ...props }) => {
  return (
    <BaseIcon {...props}>
      <path d="M14.768 4a2 2 0 0 0-1.932 1.485l-1.664 6.238a1 1 0 0 1-.259.45l-2.034 2.034a1 1 0 0 1-.707.293H6a2 2 0 0 0-2 2V26a2 2 0 0 0 2 2h15.173a5 5 0 0 0 4.916-4.09l1.457-7.864a3 3 0 0 0-2.95-3.546H19V7a3 3 0 0 0-3-3h-1.232Zm0 2H16a1 1 0 0 1 1 1v5.5a2 2 0 0 0 2 2h5.596a1 1 0 0 1 .983 1.182l-1.456 7.864A3 3 0 0 1 21.173 26H10V15.878a3 3 0 0 0 .293-.257l2.034-2.034a3 3 0 0 0 .778-1.348L14.768 6ZM8 16.5V26H6v-9.5h2Z" />
    </BaseIcon>
  );
};
